// extracted by mini-css-extract-plugin
module.exports = {"container":"base-bloc_container__1zCVL","dark":"base-bloc_dark__28UQL","light":"base-bloc_light__2adWC","link":"base-bloc_link__3DRJ5"};